import type { ThemeUnit } from "../../types";
import { pxToUnit } from "../utils";

const createDialogWidth = (unit: ThemeUnit) =>
  ({
    sm: pxToUnit(384, unit),
    md: pxToUnit(512, unit),
    lg: pxToUnit(768, unit),
    xl: pxToUnit(1152, unit),
  }) as const;

export const dialogWidthRem = createDialogWidth("rem");
